export const PERIODS = {
  defaultFormValue: 'P5Y',
  defaultCreditCardFormValue: 'P6M',
  minPeriod: 'P1D',
  maxPeriod: 'P30Y',
} as const;

export const MIN_PERIOD_DURATION = 1;
